export const searchConstants = {
    SEARCH_ORDER_SUCCESS: 'SEARCH_ORDER_SUCCESS',
    SEARCH_ORDER_FAILURE: 'SEARCH_ORDER_FAILURE',
    SEARCH_ORDER_REQUEST: 'SEARCH_ORDER_REQUEST',

};